<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">

        <!-- Business list card -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">

            <!-- 1. Loading state -->
            <div v-if="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Business List...</p>
            </div>
            <div v-else>

              <!-- ========== WHEN THERE IS DATA ========== -->
              <div v-if="businesses && businesses.length">

                <!-- Header row -->
                <div
                  class="card-header border-0 bg-transparent rounded-5 d-flex justify-content-between align-items-center"
                >
                  <h5 class="fw-500 mb-0 text-xxs">Business List</h5>
                </div>

                <!-- ===== DESKTOP (TABLE) ===== -->
                <div class="card-body table-responsive">
                  <table id="businessTable" class="table text-xxs table-striped w-100">
                    <thead class="btn-primary text-white">
                      <tr>
                        <th>No.</th>
                        <th>Business Name</th>
                        <th>Owner</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(business, index) in businesses" :key="business.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ business?.company_name }}</td>
                        <td>
                          {{ business.base_profile.creater?.first_name }}
                          {{ business.base_profile.creater?.last_name }}
                        </td>
                        <td>{{ business?.email }}</td>
                        <td>{{ business?.tell_number }}</td>
                        <td class="text-center">
                          <button
                            class="btn btn-light btn-sm rounded-3 text-success border text-xxs me-1"
                            @click="view_profile(business)"
                          >
                            View
                          </button>
                          <button
                            class="btn btn-light btn-sm rounded text-success border text-xxs d-none"
                          >
                            Edit
                          </button>
                          <button
                            class="btn btn-light btn-sm rounded-3 text-danger border text-xxs"
                            @click="delete_company_profile(business.base_profile.id)"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <!-- ========== WHEN EMPTY ========== -->
              <div v-else class="text-center py-5 border rounded-3 bg-white">
                <i
                  class="bi bi-inbox fs-1 text-muted d-block mb-2"
                  aria-hidden="true"
                ></i>
                <div class="mb-1 text-xxs">No Businesses yet</div>
                <div class="small text-muted mb-3 text-xxs">
                  Business list is empty.
                </div>
              </div>

            </div>
            <!-- /Normal content wrapper -->
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
